module.exports = __webpack_public_path__ + "img/B3_HQ01.0c4c2da5.jpg";